export const OptionSharesPerContractConstant: number = 100
